import React from "react";
import { Space, Tag } from "@pankod/refine-antd";

import { getOutcomeMetadata, getSafeText } from "../utils/audit-log.helpers";

type AuditResultTagProps = {
  outcome?: string | null;
  status?: number | string | null;
};

export const AuditResultTag: React.FC<AuditResultTagProps> = ({
  outcome,
  status,
}) => {
  const metadata = getOutcomeMetadata(outcome);

  return (
    <Space size={8} className="audit-log-result-cell">
      <span className={`audit-log-result-dot ${metadata.className}`} />
      <span className={metadata.className}>{metadata.label}</span>
      {status !== null && status !== undefined && status !== "" && (
        <Tag className="audit-log-status-tag">{getSafeText(status)}</Tag>
      )}
    </Space>
  );
};